@if (description$ | async; as description) {
  <div>
    <crm-collapsible-section [maxHeightPx]="300">
      <crm-activity-rich-text [richText]="description"></crm-activity-rich-text>
    </crm-collapsible-section>
    @if (showDirection && (direction$ | async); as direction) {
      <div class="activity-data">
        <div class="activity-data-label">
          {{ 'ACTIVITY.LOGGED_EMAIL.DIRECTION' | translate }}
        </div>
        <div class="activity-data-value">
          {{ direction === 'Sent' ? 'Outbound' : direction }}
        </div>
      </div>
    }
  </div>
}
